module.exports = __webpack_public_path__ + "img/mba-florian.c5af5b37.jpg";